<template>
  <div
    class="relative overflow-hidden rounded-xl bg-white shadow-md mt-2"
    style="width: 500px; height: 160px;"
    :data-testid="rootTestId"
  >
    <img
      :src="backgroundPattern"
      alt=""
      class="pointer-events-none absolute left-0 top-0 h-full object-cover object-left"
      style="width: 130px;"
    />

    <div class="relative flex h-full items-start px-6 py-5 pr-14">
      <div
        class="mr-5 flex h-14 w-14 flex-shrink-0 items-center justify-center rounded-full bg-white shadow-md"
      >
        <img :src="warningIcon" alt="warning" class="h-8 w-8" />
      </div>

      <div class="flex flex-1 flex-col pt-1 h-full">
        <h3
          class="mb-1 font-semibold text-black-lp-200"
          style="font-size: 16px; line-height: 28px;"
        >
          {{ title }}
        </h3>
        <p
          class="text-gray-lp-500"
          style="max-width: 400px; font-size: 14px; line-height: 24px;"
        >
          {{ message }}
        </p>
        <button
          v-if="actionLabel"
          class="mt-auto pt-2 text-left font-semibold text-red-lp-2400 focus:outline-none"
          style="font-size: 14px; line-height: 24px;"
          :data-testid="actionTestId"
          @click="$emit('action')"
        >
          {{ actionLabel }}
        </button>
      </div>

      <button
        class="absolute right-6 top-6 flex h-6 w-6 items-center justify-center text-gray-lp-500 transition-colors hover:text-gray-lp-300 focus:outline-none pt-2"
        :data-testid="dismissTestId"
        @click="$emit('close')"
      >
        <img :src="closeIcon" alt="close" class="h-5 w-5" />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "AccountAlertItem",
  props: {
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    actionLabel: {
      type: String,
      default: ""
    },
    rootTestId: {
      type: String,
      default: ""
    },
    actionTestId: {
      type: String,
      default: ""
    },
    dismissTestId: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: "lp-icon-info"
    }
  },
  emits: ["close", "action"],
  data() {
    return {
      backgroundPattern: require("@/app/ui/assets/images/bg-pattern-decorative.png"),
      closeIcon: require("@/app/ui/assets/svg/x-gray-24.svg"),
      warningIcon: require("@/app/ui/assets/svg/warning-circle.svg")
    };
  }
};
</script>
